import { render, staticRenderFns } from "./ShipmentDetailsPanel.vue?vue&type=template&id=2778ef68&scoped=true&"
import script from "./ShipmentDetailsPanel.vue?vue&type=script&lang=js&"
export * from "./ShipmentDetailsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentDetailsPanel.vue?vue&type=style&index=0&id=2778ef68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2778ef68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2778ef68')) {
      api.createRecord('2778ef68', component.options)
    } else {
      api.reload('2778ef68', component.options)
    }
    module.hot.accept("./ShipmentDetailsPanel.vue?vue&type=template&id=2778ef68&scoped=true&", function () {
      api.rerender('2778ef68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DispatchDashboard/components/ShipmentDetailsPanel.vue"
export default component.exports